import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { useIntl, FormattedMessage } from "react-intl";
import TableComponent, { OperationsCell } from '../../components/TableComponent';
import Toast from "../../helpers/Toast";
import { SortingRule } from "react-table";
import { Utilities } from "../../helpers/Utilities";
import { EquipmentDTO } from "../../models/Equipment/EquipmentDTO";
import { AssistanceCheckListService } from "../../services/AssistanceCheckListService";

type CheckListModelEquipmentProps = {
    checkListModelId: string | null,
};

function CheckListModelEquipmentComponent({ checkListModelId }: CheckListModelEquipmentProps) {
    const intl = useIntl();

    const [data, setData] = useState<EquipmentDTO[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [goToPage, setGoToPage] = useState<number>();
    const [currentSorting, setCurrentSorting] = useState<SortingRule<object>[] | null>(null);

    const service = new AssistanceCheckListService();
    const pageSizes = [5, 10, 15, 30];

    const columns = React.useMemo(() => [
        {
            Header: "",
            accessor: " ",
            Cell: (props: any) => OperationsCell(props.cell.row.original.id, "equipment"),
        },
        {
            Header: intl.formatMessage({ id: "Sceens.AssitanceCheckListEquipment.Name", defaultMessage: "Nome" }),
            accessor: "name",
        },
        {
            Header: intl.formatMessage({ id: "Screens.AssistanceCheckListEquipment.CarPlate", defaultMessage: "Matrícula" }),
            accessor: "carPlate",
        },
        {
            Header: intl.formatMessage({ id: "Screens.AssistanceCheckListEquipment.Brand", defaultMessage: "Marca" }),
            accessor: "brand",
        },
        {
            Header: intl.formatMessage({ id: "Screens.AssistanceCheckListEquipment.Model", defaultMessage: "Modelo" }),
            accessor: "model",
        },
    ], [intl]);

    const fetchData = async (page: number, size: number, sortBy: SortingRule<object>[] | null) => {
        setIsLoading(true);

        const response = await service.GetEquipmentsByCheckListModel(
            Number(checkListModelId),
            [],
            Utilities.MountSortParameters(sortBy),
            page,
            size
        );

        if (response.success) {
            setData(response.items);
            setPageCount(response.totalPages);
            setCurrentPage(page);
            setPageSize(size);
        } else {
            Toast.Show("error", response.message);
        }

        setIsLoading(false);
    };

    useEffect(() => {
        fetchData(currentPage, pageSize, currentSorting);
    }, []);

    return (
        <div className="mt-3">
            <Row>
                <Col xl={12}>
                    {data.length > 0 ? (
                        <TableComponent
                            goToPage={goToPage}
                            loading={isLoading}
                            pageCount={pageCount}
                            columns={columns}
                            manualPagination
                            fetchData={fetchData}
                            pageSizes={pageSizes}
                            initialPage={1}
                            initialPageSize={10}
                            initialSortBy={[]}
                            data={data}
                            dontOrderFirstCollumn
                        />
                    ) : (
                        !isLoading && (
                            <div className="text-center py-4 text-muted">
                                <FormattedMessage
                                    id="Screens.CheckListModelEquipment.Empty"
                                    defaultMessage="Este modelo de checklist ainda não tem equipamentos associados."
                                />
                            </div>
                        )
                    )}
                </Col>
            </Row>
        </div>
    );
}

export default CheckListModelEquipmentComponent;
